import React from "react";

interface CanvasProps {
  zoom: number;
  children: React.ReactNode;
  className?: string;
  panX?: number;
  panY?: number;
}

export default function Canvas({
  zoom,
  children,
  className,
  panX = 0,
  panY = 0,
}: CanvasProps) {
  return (
    <div
      className={className}
      style={{
        transform: `translate(${panX}px, ${panY}px) scale(${zoom})`,
        transformOrigin: "top left",
      }}
    >
      {children}
    </div>
  );
}
